import './PullToRefresh.less'
import PullToRefresh from './PullToRefresh'

export default PullToRefresh
